import { Component } from '@angular/core';
import { MenuItemComponent } from 'projects/max/dfup-storeupweb-fe/src/app/component/menu/menu-item/menu-item.component';

@Component({
  selector: 'app-menu-item-mobile',
  templateUrl: './menu-item-mobile.component.html',
  styleUrls: ['./menu-item-mobile.component.scss']
})
export class MenuItemMobileComponent extends MenuItemComponent {

}
